import { Loading } from "./Loading";

export interface TableDataPlaceholderProps {
  isFetching: boolean;
}

export const TableDataPlaceholder = ({ 
  isFetching,
}: TableDataPlaceholderProps) => {
  if (isFetching) {
    return <Loading />;
  }

  return (
    <tr className="h-4em flex items-center justify-center">
      <td className="py-8 text-center text-gray-500">
        No data available
      </td>
    </tr>
  );
};